<template>
  <div class="body">
    <div class="shell">
      <!-- 电子保单/批单 -->
      <div class="use_main">
        <div class="M-top">
          <span class="T-left">
            <h2>电子保单/批单</h2>
          </span>
        </div>
        <div class="M-buttom">
          <div class="B-left">
            <p v-for="(item , index) in ePolicyDtoList" :key="index" @click="goBDDeayil(item)">{{item.downLoadName}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/api/api.js";
import { Toast } from "vant";

export default {
  data() {
    return {
      ePolicyDtoList: [] //电子保单批单
    };
  },
  mounted: function() {
    this.queryOrderDetail();
  },

  methods: {
    queryOrderDetail() {
      Toast.loading({
        mask: true,
        duration: 0, // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: "spinner",
        message: "加载中..."
      })
      this.$http.post(api.queryOrderDetail + '?orderId=' + this.$route.query.orderId + '&fileContentFlag=0')
        .then(res => {
          Toast.clear()
          if (res.data.rtnCode === "0000") {
            if (res.data.resultObj.ePolicyDtoList !== null) {
              res.data.resultObj.ePolicyDtoList.forEach(el => {
                this.ePolicyDtoList.push(el)
              })
            }
          }
        })
        .catch(error => {
          console.log(error);
          Toast.clear()
        });
    },
    goBDDeayil(item) {
      window.open(`${process.env.API_HOST}/${item.downLoad.substring(1)}`)
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./affirmMessage.scss";
</style>



// WEBPACK FOOTER //
// src/pages/car/confirm/ElectronicPolicy.vue